module.exports = __webpack_public_path__ + "static/lamp-3cc4391fc8cc254ec4cb2862c1ff366d.jpg";